import {PickColorWithoutContainer} from "../../../../component/PickColor/PickColor";
import {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import {toastWarning} from "../../../../assets/functions";
import {getColors, getSizes, setSingleProducts} from "../../functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";

const SizeForm = ({singleProducts , onChange }) => {
    const [sizes , setSizes] = useState(getSizes(singleProducts));
    const [tempSize , setTempSize] = useState("");


    return (<div className={"card"}>
        <div className={"card-body"}>
            <div className="row">
                <label className="card-title mb-2 d-block">سایز بندی</label>
                <div className="col-7">


                    <div className="input-group mt-4">
                        <TextInputWithoutContainer placeholder={"سایز"} classname={"w-100"} value={tempSize}
                                                   onChange={(value) => {
                                                       setTempSize(value);
                                                   }}/>
                        <button className="btn btn-outline-primary" type="button" onClick={() => {
                            if (!tempSize) {
                                toastWarning("سایز را وارد نکرده اید!")
                                return;
                            }
                            setTempSize("");
                            const newSizes = [...sizes, tempSize];
                            setSizes(newSizes)
                            onChange(setSingleProducts(getColors(singleProducts), newSizes )) ;
                        }}>
                            افزودن
                        </button>
                    </div>

                </div>

                <div className="col-5">
                    <table className={"table table-borderless"}>
                        <tbody>
                        {
                            sizes.map((size, index) => {
                                return (
                                    <tr key={index}>
                                        <td className={'w-100'}>
                                            {size}
                                        </td>
                                        <td>
                                            <button className={"btn btn-danger"} onClick={() => {
                                                const newSizes = sizes.filter((s, i) => {
                                                    if (index != i)
                                                        return s;
                                                });
                                                setSizes(newSizes);
                                                onChange(setSingleProducts(getColors(singleProducts), newSizes )) ;
                                            }}><FontAwesomeIcon icon={faTrash}/></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }

                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>);

};

export default SizeForm;